/**
 * Created by Iman on 05/06/2023.
 */

import axios from "axios";
import store from "./state/store";
import router from "./router/index.js";

const axiosClient = axios.create({
   /*  baseURL: "http://laravel-canal-care-consulting.test/api/v1", */
    baseURL: "https://canal-care-consulting.ch/api/v1",
})

axiosClient.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${store.state.user.token}`
    return config;
})

axiosClient.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 401) {
        store.commit('setToken', null)
        router.push({ name: 'login' })
    }
    throw error;
})

export default axiosClient;
